import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { useInterventionCreation } from '../../context/interventionCreationContext';
import { buildSetInterventionTypePayload, buildSetInterventionTypeUrl } from './qualification';

export type SetInterventionTypeState = {
  setInterventionType: (interventionTypeCode: number) => void;
  isSaving: boolean;
  hasFailed: boolean;
};

/**
 * Enregistre le type d'intervention des demandes cochées dès sa sélection, sans
 * attendre « Qualifier » et sans changer leur statut : la table est simplement
 * rafraîchie pour refléter la nouvelle valeur.
 */
export function useSetInterventionType(): SetInterventionTypeState {
  const { state, dispatch } = useInterventionCreation();
  const queryClient = useQueryClient();

  // Le nombre de demandes remonte de la mutation plutôt que d'être relu à l'arrivée : la
  // sélection peut changer pendant l'appel, le bilan doit dire ce qui a réellement été
  // enregistré.
  const mutation = useMutation<number, unknown, number>({
    mutationFn: async (interventionTypeCode) => {
      if (state.clientId === null) {
        throw new Error('Aucun client sélectionné');
      }

      const savedIds = state.selectedRequestIds;

      await axios.post(
        buildSetInterventionTypeUrl(state.clientId),
        buildSetInterventionTypePayload(interventionTypeCode, savedIds)
      );

      return savedIds.length;
    },
    onSuccess: (savedCount) => {
      // La colonne « qualification » de la table relit le type et la configuration :
      // une demande qui n'a que son type s'y affiche « Incomplète ».
      queryClient.invalidateQueries(['exocet-pds-to-qualify']);

      dispatch({ type: 'reportInterventionType', report: { savedCount } });
    }
  });

  return {
    setInterventionType: mutation.mutate,
    isSaving: mutation.isLoading,
    hasFailed: mutation.isError
  };
}
